/* eslint-disable no-undef */
import styled from 'styled-components';

export const Cards = styled.div`
  box-sizing: border-box;
  margin-bottom: 10px;
  color: ${({ theme }) => {
    return theme.colors.primary;
  }};
  font-family: inherit;
  background-color: ${({ theme }) => {
    return theme.colors.white;
  }};
  box-shadow: 0px 0px 0px 1px
    ${({ theme }) => {
      return theme.colors.darkPrimary;
    }};
  border-radius: 5px;
`;

export const CardHeader = styled.div`
  display: flex;
  justify-content: space-between;
  padding: 10px;
  border-radius: 3px 3px 0 0;
  background-color: ${({ isActive, accessMode, theme }) => {
    if (isActive) {
      if (accessMode === process.env.REACT_APP_DEV_ACCESS) {
        return theme.colors.devAccess;
      } else if (accessMode === process.env.REACT_APP_ADMIN_SINCRONIZA_ACCESS) {
        return theme.colors.sincronizaAdminAccess;
      } else if (accessMode === process.env.REACT_APP_USER_SINCRONIZA_ACCESS) {
        return theme.colors.sincronizaUserAccess;
      } else if (accessMode === process.env.REACT_APP_ADMIN_SPA_ACCESS) {
        return theme.colors.SpaAdminAccess;
      } else if (accessMode === process.env.REACT_APP_USER_SPA_ACCESS) {
        return theme.colors.SpaUserAccess;
      } else if (accessMode === process.env.REACT_APP_ACCESSKEY_NEW_SYSTEM) {
        return theme.colors.NewSystem;
      } else if (accessMode === process.env.REACT_APP_SUPORTE_SINCRONIZA_ACCESS) {
        return theme.colors.sincronizaSuporteAccess;
      }
    } else {
      return theme.colors.error;
    }
  }};
  color: ${({ theme }) => {
    return theme.colors.white;
  }};
  h3,
  h4 {
    margin: 0;
    font-size: ${({ theme }) => {
      return theme.fonts.size.big;
    }};
    font-weight: ${({ theme }) => {
      return theme.fonts.weight.thin;
    }};
  }
`;

export const CardBody = styled.div`
  display: flex;
  justify-content: space-between;
  padding: 10px;
  p {
    margin: 0;
    font-size: ${({ theme }) => {
      return theme.fonts.size.normal;
    }};
    font-weight: ${({ theme }) => {
      return theme.fonts.weight.thin;
    }};
  }
`;

export const TitleCardsCompanies = styled.h4`
  padding: 10px;
  margin: 0;
  font-size: ${({ theme }) => {
    return theme.fonts.size.normal;
  }};
  font-weight: ${({ theme }) => {
    return theme.fonts.weight.thin;
  }};
`;

export const WrapperCardsCompanies = styled.div`
  display: flex;
  flex-flow: row wrap;
  width: 100%;
  padding: 10px;
`;

export const CardCompany = styled.div`
  margin-right: 5px;
  padding: 5px;
  border: 1px solid
    ${({ theme }) => {
      return theme.colors.darkPrimary;
    }};
  border-radius: ${({ theme }) => {
    return theme.borderRadius.small;
  }};
  h4,
  p {
    margin: 0 0 5px 0;
    font-weight: ${({ theme }) => {
      return theme.fonts.weight.thin;
    }};
  }
`;

export const CardFooter = styled.div`
  height: 35px;
  a {
    font-size: ${({ theme }) => {
      return theme.fonts.size.normal;
    }};
    font-weight: ${({ theme }) => {
      return theme.fonts.weight.thin;
    }};
    margin: 10px 0 25px 10px;
    padding: 5px;
    text-decoration: none;
    cursor: pointer;
    color: ${({ theme }) => {
      return theme.colors.primary;
    }};
    border: 1px solid
      ${({ theme }) => {
        return theme.colors.darkPrimary;
      }};
    border-radius: ${({ theme }) => {
      return theme.borderRadius.small;
    }};
    transition: background-color 200ms ease-in-out;
    &:hover {
      color: ${({ theme }) => {
        return theme.colors.white;
      }};
      background-color: ${({ theme }) => {
        return theme.colors.primary;
      }};
    }
  }
`;
